import { render, staticRenderFns } from "./SupervisorReview.vue?vue&type=template&id=750c3bfe"
import script from "./SupervisorReview.vue?vue&type=script&lang=js"
export * from "./SupervisorReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports